/*
 * Title: Reconcile In Bulk
 * Description: Interactive bulk stock reconciliation page
 */

import { useAuth } from '../../contexts/AuthContext';
import { ReconcileInBulkProvider } from '../centerWarehouse/reconcileInBulk/ContextAPI';
import Index from '../centerWarehouse/reconcileInBulk/Index';
import ReconcileModal from '../centerWarehouse/reconcileInBulk/ReconcileModal';
import ImportPreviewModal from '../centerWarehouse/reconcileInBulk/ImportPreviewModal';
import PermissionDenied from './PermissionDenied';

export default function ReconcileInBulk() {
    const { auth } = useAuth();
    const { route_permissions } = auth;

    if (!route_permissions['reconcile-in-bulk']) return <PermissionDenied />;

    return (
        <ReconcileInBulkProvider>
            <Index />
            <ReconcileModal />
            <ImportPreviewModal />
        </ReconcileInBulkProvider>
    );
}